import { Userpilot } from 'userpilot'

// Thin wrapper: the SDK throws when used before initialize(), and in hosted
// mode the Vue 2 bundle owns the Userpilot lifecycle — so every call here is
// guarded on our own initialize() having run.
let initialized = false

export const userpilot = {
  initialize(token = 'NX-482874b5') {
    if (initialized) return
    Userpilot.initialize(token)
    initialized = true
  },
  identify(...args) {
    if (initialized) Userpilot.identify(...args)
  },
  suppress() {
    if (initialized) Userpilot.suppress()
  },
  unsuppress() {
    if (initialized) Userpilot.unsuppress()
  },
  reload() {
    if (initialized) Userpilot.reload()
  },
}
